import { Area, AreaContent } from "../../useAreas/areas/types";
import hero from "../../../../assets/image/areas/hero/itUndDatenschutzrecht.webp";

// Hinweis: Fachlicher Arbeitsstand "Datenschutzrecht" – finale inhaltliche
// Freigabe/Ergänzung durch Thorsten Müller-Winterhager steht noch aus.
const data: AreaContent = {
  id: Area.ITUNDDATENRECHT,
  hero: hero,
  content: [
    "Wir beraten Unternehmen, Selbstständige und gewerbliche Anbieter:innen im Internet zu datenschutzrechtlichen, IT-rechtlichen und internetrechtlichen Fragestellungen.",
    "Dabei unterstützen wir Sie bei der rechtssicheren Gestaltung digitaler Angebote, beim Umgang mit personenbezogenen Daten sowie bei Verträgen rund um Software, IT-Projekte und Online-Angebote.",

    "<strong>Datenschutzrecht</strong>",
    "Der Schutz personenbezogener Daten von Mitarbeiter:innen, Kund:innen und Nutzer:innen ist für Unternehmen von zentraler Bedeutung. Neben technisch-organisatorischen Maßnahmen sind dabei auch rechtliche Vorgaben zu beachten.",
    "Wir beraten und unterstützen Sie insbesondere bei:",
    [
      "Erstellung und Anpassung von Datenschutzerklärungen",
      "Prüfung datenschutzrechtlicher Informationspflichten",
      "Gestaltung von Datenverarbeitungsprozessen",
      "Fragen zur Auftragsverarbeitung",
      "Betriebsvereinbarungen zum Datenschutz",
      "Schulungen zu Grundlagen des Datenschutzrechts",
      "Prüfung, ob eine Datenschutzbeauftragte oder ein Datenschutzbeauftragter zu benennen ist",
    ],

    "<strong>IT-Recht und Internetrecht</strong>",
    "Wir beraten Sie beim Abschluss von Verträgen über den Erwerb oder die Lizenzierung von Software sowie bei Verträgen über die Beauftragung und Durchführung von IT-Projekten.",
    "Darüber hinaus unterstützen wir Online-Händler:innen und andere gewerbliche Anbieter:innen bei der rechtssicheren Gestaltung ihrer Internetangebote, insbesondere bei:",
    [
      "Softwareverträgen, Lizenzverträgen und IT-Projektverträgen",
      "Online-AGB",
      "Widerrufsrecht und Pflichtangaben",
      "rechtlicher Prüfung von Online-Shops",
      "Impressum und Datenschutzerklärung",
      "Newsletterversand",
      "Domainrecht",
      "Keyword Advertising, zum Beispiel Google Ads",
      "Abmahnungen und Unterlassungserklärungen",
    ],

    "<strong>Social Media, Verbraucher:innenrechte und Filesharing</strong>",
    "Auch bei Social-Media-Angeboten, digitalen Inhalten und Verbraucher:innenrechten stellen sich regelmäßig rechtliche Fragen. Wir beraten insbesondere zu Pflichtangaben, Haftungsfragen, rechtsverletzenden Äußerungen, Plattformnutzung und der Durchsetzung oder Abwehr rechtlicher Ansprüche.",
    "Nach Erhalt einer Abmahnung, etwa im Bereich Filesharing oder wegen angeblicher Rechtsverletzungen im Internet, prüfen wir die Begründetheit der Abmahnung und übernehmen die weitere Korrespondenz mit den abmahnenden Rechtsanwält:innen.",
  ],
  bullets: [
    "Datenschutzrecht",
    "Datenschutzerklärungen",
    "Auftragsverarbeitung",
    "Betriebsvereinbarungen zum Datenschutz",
    "Schulungen im Datenschutz",
    "IT-Verträge",
    "Lizenzverträge",
    "Internetrecht",
    "Online-AGB",
    "Online-Shops",
    "Social Media",
    "Domains",
    "Filesharing",
    "Abmahnungen",
  ],
  more: [],
};

export default data;
